import { Configuration, OpenAIApi } from 'openai';
import { cv_success, dispatchSpanish } from './ActionCreator';
//    " School, Degree, Course, Course should be a string inside of Education object array and not an array, Start_date, End_date, Interest, CvType, Award, Education, Experience, Technical_skills, Personal_skills"
// Education, Experience, Technical_skills, Personal_skills, Award should all be in an array.`

export const processValues = (arg) => {
  const main_value = arg;
  delete main_value.Experience;
  delete main_value.Interest;
  delete main_value.Education;
  delete main_value.Award
  delete main_value.Technical_skills;
  delete main_value.Personal_skills;
  delete main_value.Professional_summary
  return main_value;
}

export const convert = (cred) => async (dispatch) => {
  const valueToBeMapped = { "Fullname": cred.Fullname, "Address": cred.Address, "Email": cred.Email, "Phone_number": cred.Phone_number, "Lang": cred.Lang, "Reference": cred.Reference, "Language": cred.Language, "Website": cred.Website, "Linkedin": cred.Linkedin };
  console.log("type", cred.Lang[0].lang)
    const detailsToFilter = { ...cred};
    delete detailsToFilter.Fullname;
    delete detailsToFilter.Address;
    delete detailsToFilter.Email;
    delete detailsToFilter.Phone_number;
    delete detailsToFilter.Language;
    delete detailsToFilter.Website;
    delete detailsToFilter.Linkedin;
  
    const userInformation = `${JSON.stringify(detailsToFilter)}`;

    const command = `Strictly examine and convert all values of this object ${userInformation} into ${cred.Lang[0].lang}. All keys should be in English while values should be changed to ${cred.Lang[0].lang}. Do not truncated "Experience" array or any array for brevity but strictly return all the experiences array, make sure to return everything.
    Return the response or result exactly in object-readable format following this key:
    "Professional_summary, School, Degree, Course, Course should be a string inside of Education object array and not an array, Start_date, End_date, Interest, CvType, Award, Education, Experience, Technical_skills, Personal_skills"
    Education, Experience, Technical_skills, Personal_skills, Award should all be in an array.`
     
  
    const configuration = new Configuration({
      apiKey: "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",
    });

    delete configuration.baseOptions.headers['User-Agent'];
    const openai = new OpenAIApi(configuration);
    openai.createChatCompletion({
      model: 'gpt-3.5-turbo',
      messages: [{ role: 'user', content: command}],
      temperature: 0
    }).then(resp => {
      const result = resp.data.choices[0].message.content;
      console.log("result", result);
      let r1 = result.replace('\n', "");cred.Lang[0].lang
      console.log("r1", r1)
      console.log("Strip!!!", r1.slice(r1.indexOf('{'), r1.lastIndexOf('}') + 1));
      const r2 = r1.slice(r1.indexOf('{'), r1.lastIndexOf('}') + 1);
      const final_result = {...valueToBeMapped, ...JSON.parse(r2)};
      console.log("keys after parsing", Object.keys(final_result));
  
      console.log("final_result", final_result);
      dispatch(dispatchSpanish(final_result));
      dispatch(cv_success(final_result));
    })
}